import { DESCRIPTION_MAX_LENGTH } from '../../../config/constants';

interface IValidateDescriptionFieldArgs {
  draftValue: string;
  originalValue?: string;
}

export const useValidateDescriptionField = ({
  draftValue,
  originalValue = '',
}: IValidateDescriptionFieldArgs) => {
  const trimmed = draftValue.trim();

  const isValid = trimmed.length <= DESCRIPTION_MAX_LENGTH;

  const isDirty = trimmed !== originalValue;

  return {
    isValid,
    isDirty,
  };
};
